import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useIntl } from 'umi';
import { RPDMetricColumn } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RPDCloums';
import { tableDataFormatKMB, pageAble } from '@/pages/intelligence/utils/commonUtils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';

const ChannelsCard = (props: any) => {
  const {
    tableData = [],
    unPublishedAppIdList,
    chartSegment,
    asForDate = '',
    fixedTableData,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
    entityType,
    dataSource,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { rpdListDetail } = useMobileOptionList({ asForDate });

  useEffect(() => {
    onSortChage({
      sortMetric: defaultPageSortAttr?.currentSortMetric,
      sortVal: defaultPageSortAttr?.currentSortValue,
      ratioType: defaultPageSortAttr?.currentRatioType,
    });
    setPageSortAttr(defaultPageSortAttr);
  }, [tableData, defaultPageSortAttr]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'date',
      metricProperty: 'name',
    });
    const pageList: any[] = pageAble(sortTable, pageIndex, pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    setSortTableData(sortTable.slice(0));
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || 5);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex, e.pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
  };

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    const metrics = cvm?.metrics || [];
    const metric = metrics.find((item: any) => {
      return item?.name === metricKey;
    });
    return tableDataFormatKMB(metric?.value);
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];

    rpdListDetail.forEach((t) => {
      metricCloums.push(
        RPDMetricColumn(
          {
            width: t.width,
            width_cn: t?.width_cn ?? t.width,
            // dataSource: source, //source === 'ogdb' ? 'databarin' : source,
            title: t.title,
            textContent: t.textContent,
            key: `${t.key}`,
            metricKey: t?.metricKey || t?.key,
            sortMetric: t.key,
            isNoDropdown: !(chartSegment === t.key),
            currentSortValue: pageSortAttr?.currentSortValue,
            currentSortKey: `${pageSortAttr?.currentSortMetric}`,
            onSortChage: handleSortChange,
            getMetricValueOfCvm,
            entityType,
          },
          dataSource,
        ),
      );
    });
    return metricCloums;
  };

  return (
    <>
      <TopchartTable
        className="dbi-mobileGames-details-table"
        loading={false}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        columns={[
          {
            key: 'app_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_top_editions' })}
                </span>
                <span className="stats-table-title-subtext">({sortTableData?.length || 0})</span>
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              const isUnPublished = unPublishedAppIdList?.includes(cvm?.app_id);
              if (cvm?.name === 'Total') {
                return <>Total</>;
              }
              return (
                <FirstRowEdition
                  name={cvm?.name}
                  isUnPublished={isUnPublished}
                  platform={cvm?.platform}
                  imgSrc={cvm?.cover}
                />
              );
            },
          },
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default ChannelsCard;
